<template>
  <div>
    <h3 class="title">検索条件</h3>
    <ValidationObserver ref="observer" tag="form">
      <table class="table">
        <tbody>
          <tr>
            <td>棚卸識別名</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="max:50">
                <input id="inventoryName" type="text" :name="itemName.inventoryName" class="form-control enterp-codeInput"
                  autocomplete="off" v-model="inventoryName" />
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td>拠点コード</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="alpha_num|max:16">
                <input id="sectionCode" type="text" :name="itemName.sectionCode" class="form-control enterp-codeInput"
                  autocomplete="off" v-model="sectionCode" />
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td>棚卸状態</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="oneOf:0,1,2,3">
                <select id="inventoryStatus" :name="itemName.inventoryStatus" class="form-control enterp-codeInput" v-model="inventoryStatus">
                  <option value="">選択して下さい</option>
                  <option :value="0">棚卸準備中</option>
                  <option :value="1">棚卸中</option>
                  <option :value="2">完了</option>
                  <option :value="3">承認済</option>
                </select>
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td>表示条件</td>
            <td>
              <select id="sortDiv" class="form-control enterp-codeInput" v-model="sortDiv">
                <option value="">全て</option>
                <option :value="0">作成日時の最新のみ</option>
                <option :value="1" selected>更新日時の最新のみ</option>
              </select>
            </td>
          </tr>
          <!-- <tr>
            <td>棚卸情報作成日</td>
            <td>
              <input type='text' name="from" class="form-control dateInput datepicker" autocomplete="off" />
                ～
              <input id="to" type='text' name="to" class="form-control dateInput datepicker" autocomplete="off"/>
            </td>
          </tr> -->
        </tbody>
      </table>
    </ValidationObserver>
    <RfidButton :display="'inline'" @handleClick="search">検索</RfidButton>
    <br><br>
  </div>
</template>

<script>
import RfidButton from '@/components/atoms/RfidButton'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'enterprise-search-window',

  components: {
    ValidationObserver,
    ValidationProvider,
    RfidButton
  },

  data () {
    return {
      inventoryName: '',
      sectionCode: '',
      inventoryStatus: '',
      sortDiv: '',
      itemName: {}
    }
  },

  created () {
    this.itemName = this.item()
    this.sortDiv = 1
  },

  methods: {
    async search () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }
      this.$emit('search', this.inventoryName, this.sectionCode, this.inventoryStatus, this.sortDiv)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/InventoryInfoSearchWindow.vue